<template>
  <div class='m-map'>
    <ul class='m-map__options list-unstyled'>
      <li>
        <div class='checkbox'>
          <label>
            <input type='checkbox' checked='checked' @click='updateParksMarkers'> {{ $t('content.tecnoparks') }}
          </label>
        </div>
      </li>
      <li>
        <div class='checkbox'>
          <label>
            <input type='checkbox' @click='updateCompaniesMarkers'> {{ $t('commons.companies') }}
          </label>
        </div>
      </li>
    </ul>
    <center>
      <gmap-map
      :center='center'
      :zoom='zoom'
      map-type-id='terrain'
      :bounds='bounds'
      :style='style'
      ref='map'
      :options='options'>
        <template v-for='institution in markers'>
          <gmap-marker
          :key='index'
          v-for='(p, index) in institution.positions'
          :position='p'
          :clickable='false'
          :draggable='false'
          :icon='getMarkerIcon(institution.color)'
          @click='center=m.position'>
        </gmap-marker>
      </template>
  </gmap-map>
</center>
</div>
</template>

<script>
import {BackendApi} from '@/services/backend_api'

export default {
  name: 'Map',
  data () {
    return {
      bounds: {
        north: 33.685,
        south: 50.671,
        east: -70.234,
        west: -116.251
      },
      options: {
        draggable: false,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true
      },
      zoom: 4,
      style: 'width: 500px; height: 500px',
      center: {
        lat: -15.54,
        lng: -55.95
      },
      markers: {
        parks: {
          positions: [],
          color: '#2C698C'
        },
        companies: {
          positions: [],
          color: '#73B0D3'
        }
      }
    }
  },
  mounted () {
    const map = this.$refs.map
    map.$mapCreated.then(() => {
      var square = new window.google.maps.KmlLayer({
        url: 'https://www.inovadatabr.com.br/static/kml/big_square.kml?avoidingCache=' + (new Date()).getTime(),
        map: map.$mapObject,
        preserveViewport: true,
        clickable: false
      })
      var that = this
      window.google.maps.event.addListener(square, 'status_changed', function () {
        if (square.getStatus() === window.google.maps.KmlLayerStatus.OK) {
          that.updateMapSizeIfNeeded()
          const brazilMkl = new window.google.maps.KmlLayer({
            url: 'https://www.inovadatabr.com.br/static/kml/brasil_map.kml?avoidingCache=' + (new Date()).getTime(),
            map: map.$mapObject,
            preserveViewport: true,
            clickable: false
          })
          that.addParksMarkers()
          return brazilMkl
        }
      })
    })
  },
  methods: {
    getMarkerIcon (color) {
      return {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 5,
        strokeColor: color,
        fillColor: color,
        fillOpacity: 1
      }
    },
    updateMapSizeIfNeeded () {
      if (document.documentElement.clientWidth > 550) {
        return
      }
      this.resizeMapToXsDevices()
    },
    resizeMapToXsDevices () {
      this.center = { lat: -34.54, lng: -40.95 }
      this.style = 'width: 300px; height: 255px'
      this.$refs.map.$mapObject.setZoom(3)
    },
    updateParksMarkers (event) {
      if (event.target.checked) {
        this.addParksMarkers()
        return
      }
      this.markers.parks.positions = []
    },
    addParksMarkers () {
      BackendApi.get(BackendApi.getAnonymousClient(), '/lat-lngs/parks')
      .then(r => {
        for (let park in r.data) {
          if (r.data[park].lat && r.data[park].lng) {
            this.markers.parks.positions.push({ lat: r.data[park].lat, lng: r.data[park].lng })
          }
        }
      })
    },
    updateCompaniesMarkers (event) {
      if (event.target.checked) {
        this.addCompaniesMarkers()
        return
      }
      this.markers.companies.positions = []
    },
    addCompaniesMarkers () {
      BackendApi.get(BackendApi.getAnonymousClient(), '/lat-lngs/companies')
      .then(r => {
        for (let company in r.data) {
          if (r.data[company].lat && r.data[company].lng) {
            this.markers.companies.positions.push({ lat: r.data[company].lat, lng: r.data[company].lng })
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Map.vue?742b304a